import React, { useContext, useRef, useEffect } from 'react';
import { setClassNames } from 'ddc-classnames-js';
import { useRequestData } from 'wsm-common-data';
import { FetchReviewsContext } from '../providers/FetchReviewsProvider';
import RatingFilters from './RatingFilters';
import ModelFilters from './ModelFilters';
import TypeFilters from './TypeFilters';

const Filters = () => {
	// hooks
	const { deviceType } = useRequestData();
	/**
	 * @type {FetchReviewsContextValue}
	 */
	const { isLoading, idle } = useContext(FetchReviewsContext);
	const filtersSectionRef = useRef(null);
	useEffect(() => {
		if (isLoading || idle) {
			return;
		}
		filtersSectionRef.current.scrollIntoView({
			behavior: 'smooth',
			block: 'end'
		});
	}, [isLoading, idle]);
	// variables
	const isDesktop = deviceType === 'DESKTOP';
	// classes
	const filtersClasses = [
		isDesktop ? '' : 'ddc-font-size-large',
		isLoading ? 'overlay' : ''
	];
	return (
		<section
			ref={filtersSectionRef}
			className={setClassNames(filtersClasses)}
		>
			<div className="row">
				{isLoading && (
					<i
						role="status"
						className="spinner"
						aria-label="loading"
						aria-live="polite"
					/>
				)}
				<div className="col-sm-offset-1 col-sm-3">
					<RatingFilters />
				</div>
				<div className="col-sm-4">
					<ModelFilters />
				</div>
				<div className="col-sm-3">
					<TypeFilters />
				</div>
			</div>
		</section>
	);
};

export default Filters;
